import styles from "./styles.module.css";
import Toggle from "./toggle";
import Tables from "./tables";
import Roles from "./roles";
import Add from "./add";

export default function Sidebar({ tab, active, setActive, toggle }) {
  const handleClick = (index) => {
    setActive(index);
  };

  const handleToggle = () => {
    setActive(null);
    toggle(tab);
  };

  return (
    <div className={styles.sidebar}>
      {/* <Toggle tab={tab} setTab={handleToggle} /> */}
      <Add />
      <Tables open={tab === "tables"} active={active} onClick={handleClick} />
      <Roles open={tab === "roles"} active={active} onClick={handleClick} />
    </div>
  );
}
